module.exports = __webpack_public_path__ + "static/media/arrow_next_white.d5d3a7df.svg";